import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { features } from '../mockData';
import { Tabs, TabsList, TabsTrigger, TabsContent } from './ui/tabs';

const Features = () => {
  const [activeTab, setActiveTab] = useState('students');

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Features for <span className="text-cyan-600">Everyone</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Tailored experiences for students, parents, and tutors
          </p>
        </motion.div>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="grid w-full max-w-2xl mx-auto grid-cols-3 mb-12 h-auto p-2 bg-gray-100 rounded-2xl">
            <TabsTrigger 
              value="students" 
              className="text-base py-3 rounded-xl data-[state=active]:bg-cyan-600 data-[state=active]:text-white transition-all duration-300"
            >
              For Students
            </TabsTrigger>
            <TabsTrigger 
              value="parents" 
              className="text-base py-3 rounded-xl data-[state=active]:bg-cyan-600 data-[state=active]:text-white transition-all duration-300"
            >
              For Parents
            </TabsTrigger>
            <TabsTrigger 
              value="tutors" 
              className="text-base py-3 rounded-xl data-[state=active]:bg-cyan-600 data-[state=active]:text-white transition-all duration-300"
            >
              For Tutors
            </TabsTrigger>
          </TabsList>

          <AnimatePresence mode="wait">
            {['students', 'parents', 'tutors'].map((tab) => (
              <TabsContent key={tab} value={tab} className="mt-0">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.4 }}
                  className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto"
                >
                  {features[tab].map((feature, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: index * 0.1, duration: 0.4 }}
                      whileHover={{ scale: 1.02 }}
                      className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-2xl p-6 shadow-md hover:shadow-lg transition-all duration-300"
                    >
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-8 h-8 bg-cyan-600 rounded-full flex items-center justify-center mt-1">
                          <CheckCircle className="w-5 h-5 text-white" />
                        </div>
                        <div className="flex-1">
                          <h4 className="text-lg font-bold text-gray-900 mb-2">
                            {feature.title}
                          </h4>
                          <p className="text-gray-600">
                            {feature.description}
                          </p>
                        </div>
                      </div>
                    </motion.div>
                  ))}
                </motion.div>
              </TabsContent>
            ))}
          </AnimatePresence>
        </Tabs>
      </div>
    </section>
  );
};

export default Features;